const HomeCardPlaceHolder = () => (
  <img
    alt="homecard-placeholder"
    className="l-list__placeholder"
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAj8AAAHnAgMAAAAqR9R7AAAADFBMVEX////Y2Ni0tLTq6uqssKLrAAABNElEQVR42u3Wyw1AUBRF0ZPoRhOaoEiqUNhLKMAvBuKFtYfnTtbwZqirPkBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQECVgqajRiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICCgr4OGugICAgICAgICAgICAgICAgICAgI6B0mSJEmSJElJO70aEBAQEBAQEBCQJEmSJEnSo3XL7ZJkZy6bvQABAQEBAQEBAQEBAUmSJP2+iwdtTtIcnwsQEBAQEBAQEBAQEJAkSZIkSZIk6Y1Wi0r/JbK2OwUAAAAASUVORK5CYII="
  />
);

export default HomeCardPlaceHolder;
